import HttpRequest from './HttpRequest';

export default class BusinessService extends HttpRequest {
  static endpoint = 'business';

  static async getAll() {
    this.endpoint = 'business';
    const response = await this.get();
    return response;
  }
}
